import { render, staticRenderFns } from "./UpdateModule.vue?vue&type=template&id=9c5ac504&scoped=true"
import script from "./UpdateModule.vue?vue&type=script&lang=js"
export * from "./UpdateModule.vue?vue&type=script&lang=js"
import style0 from "./UpdateModule.vue?vue&type=style&index=0&id=9c5ac504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5ac504",
  null
  
)

export default component.exports